import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {

  }

  navigate(url:string){
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts